import { AppointmentDetails } from '@dreryk/egabinet-appointment-frontend-api';
import { PhoneNumber } from '@dreryk/phone-number-common-api';
import { Money } from '@dreryk/money-common-api';

import { useFormController } from '@dreryk/react-common';
import { PhoneNumberInput } from '@dreryk/react-components';

import {
   AppointmentBeginDateTextView,
   AppointmentPatientTextView,
   AppointmentPractitionerTextView,
} from '~libs.desktop.shared.appointment';

import { translationKeys } from '../../../translations';
import { AdvancePaymentPhoneNumberSmsCapabilitiesNotification } from '../../../components/AdvancePaymentPhoneNumberSmsCapabilitiesNotification';
import { AdvancePaymentRequiredAmountForLinkTextView } from '../../../components/AdvancePaymentRequiredAmountForLinkTextView';

import {
   AdvancePaymentAdditionalPaymentFormBean,
   AdvancePaymentAdditionalPaymentFormController,
} from './AdvancePaymentAdditionalPaymentForm.types';
import { OneColumnSpan, StyledForm } from './AdvancePaymentAdditionalPaymentForm.styled';

type AdvancePaymentAdditionalPaymentFormRenderProps = Pick<
   AdvancePaymentAdditionalPaymentFormController,
   'handleSubmit' | 'formState' | 'trigger'
>;

type AdvancePaymentAdditionalPaymentFormProps = {
   children: (renderProps: AdvancePaymentAdditionalPaymentFormRenderProps) => JSX.Element;
   appointmentDetails: AppointmentDetails;
   patientPhoneNumber: PhoneNumber | undefined;
   requiredAmount: Money;
};

export const AdvancePaymentAdditionalPaymentForm = (props: AdvancePaymentAdditionalPaymentFormProps): JSX.Element => {
   const {
      register,
      handleSubmit,
      formState,
      watch,
      trigger,
   } = useFormController<AdvancePaymentAdditionalPaymentFormBean>({
      patientPhoneNumber: props.patientPhoneNumber ?? null,
   });

   const patientPhoneNumber = watch('patientPhoneNumber');

   return (
      <StyledForm noValidate>
         <AppointmentBeginDateTextView beginDate={props.appointmentDetails.beginDate} />
         <AppointmentPatientTextView patient={props.appointmentDetails.patient} />

         <OneColumnSpan>
            <AppointmentPractitionerTextView practitioner={props.appointmentDetails.practitioner} />
         </OneColumnSpan>

         <OneColumnSpan>
            <AdvancePaymentRequiredAmountForLinkTextView requiredAmount={props.requiredAmount} />
         </OneColumnSpan>

         <OneColumnSpan>
            <PhoneNumberInput
               controller={register('patientPhoneNumber', { required: true })}
               testId={'patientPhoneNumber'}
               label={translationKeys.phoneNumberForLinkSending}
            />
            <AdvancePaymentPhoneNumberSmsCapabilitiesNotification phoneNumber={patientPhoneNumber} />
         </OneColumnSpan>

         {props.children({
            handleSubmit: handleSubmit,
            formState: formState,
            trigger: trigger,
         })}
      </StyledForm>
   );
};
